import { render, staticRenderFns } from "./TheTopBar.vue?vue&type=template&id=35ac4753&scoped=true&"
import script from "./TheTopBar.vue?vue&type=script&lang=js&"
export * from "./TheTopBar.vue?vue&type=script&lang=js&"
import style0 from "./TheTopBar.vue?vue&type=style&index=0&id=35ac4753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac4753",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VFlex,VLayout})
